import React, { useState, useEffect } from "react";

import Loading from "../components/Loading";
import PresenceMap from "../components/PresenceMap";
import LoadCountriesTask from "../tasks/LoadCountriesTaskPresence";
import ReactGA from 'react-ga';

const TRACKING_ID ="G-2D7RRR14SS";
ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname + window.location.search);


function PresenceOfLawsThatAffectCSOs() {
  const [countries, setCountries] = useState([]);

  const load = () => {
    console.log("load");
    const loadCountriesTask = new LoadCountriesTask();
    loadCountriesTask.load((countries) => setCountries(countries));
  };
  console.log(countries)

  useEffect(load, []);

  return (
    <div>
      {countries.length === 0 ? (
        <Loading />
      ) : (
        <div >
          <PresenceMap
 countries={countries} />
        </div>
      )}
    </div>
  );
};

export default PresenceOfLawsThatAffectCSOs